<template>
  <div>
    <InputGroup icon="icontel" placeholder="请输入手机号" v-model="mobile"></InputGroup>

    <div class="login-item" >
      <InputGroup  class="login-item-input" placeholder-class="login-item-i-p fsz26" type="text" v-model="captcha" placeholder="输入图片验证码" style="width: 100%" ></InputGroup>
      <img class="codeimg" :src="captchaUrl" alt="" @click="getCodeImg" />
    </div>
    
    <InputGroup placeholder="请输入验证码" v-model="code">
      <div class="code-btn" @click="sendCode" v-show="verification">{{sendText}}</div>
      <div class="code-btn not" v-show="!verification">重新发送({{timer}})</div>
    </InputGroup>
  </div>
</template>

<script>
import InputGroup from "@/components/layout/InputGroup.vue";
import { apiBaseUrl } from '@/config/env.js'
export default {
  name: "CodeInputGroup",
  components: { InputGroup },
  props:["telphone"],
  data() {
    return {
      mobile: "",
      code: "",
      verification: true,
      sendText: "获取验证码",
      timer: 60,
      auth_timer: "",
      captcha: '', // 输入的验证码
      captchaUrl: '', // 验证码图片地址
    };
  },
  watch: {
    mobile(val) {
      this.$emit("getTelPhone", val);
      this.$emit("getInputError", this.rightMobile.msg);
    },
    code(val) {
      this.$emit("getSmsCode", val);
    },
    captcha(val) {
      this.$emit("getCaptcha", val);
    }
  },
   mounted() {
    this.getCodeImg()
    if(this.telphone){
      this.mobile=this.telphone;
    }
  },
  computed: {
    // 验证手机号
    rightMobile() {
      let res = {};
      if (!this.mobile) {
        res.status = false;
        res.msg = "请输入手机号";
      } else if (!/^1[345678]{1}\d{9}$/gi.test(this.mobile)) {
        res.status = false;
        res.msg = "手机号格式不正确";
      } else {
        res.status = true;
        res.msg=""
      }
      return res;
    }
  },
  methods: {
      // 获取验证码图片地址
    getCaptchaUrl() {
      // this.captchaUrl = apiBaseUrl + 'captcha.html'
     
      // this.captchaUrl = apiBaseUrl + '/b2c/common/verify'
      this.getCodeImg()
      
    },
    getCodeImg() {
      let num = Math.ceil(Math.random() * 1000)
      this.$api.userCaptcha({num}).then(res => {
        this.captchaUrl = res.data
      })
      // this.captchaUrl = apiBaseUrl + 'captcha.html?' + num
    },
    sendCode() {
      if (!this.rightMobile.status) {
        return this.$emit("getInputError", this.rightMobile.msg);
      } if (!this.captcha) {
        return this.$emit("getInputError", '请输入图片验证码');
      }else {
        this.$api.sms({ mobile: this.mobile, code: "login", captcha: this.captcha }).then(res => {
          if (res.status) {
            this.verification = false;
            this.countDown(); // 执行验证码计时
          } else {
            this.$emit("getInputError", res.msg);
          }
        });
      }
    },
    countDown() {
      let auth_timer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.verification = true; // 60s时间结束还原v-show状态并清除定时器
          this.timer = 60;
          clearInterval(auth_timer);
          this.sendText = "重新发送";
        }
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.auth_timer);
  }
};
</script>
<style lang="scss" scoped>
.code-btn {
  width: 84px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #ea4b49;
  font-weight: 400;
  border-left: 1px solid rgba(220, 220, 220, 1);
  cursor: pointer;
  &.not {
    color: #999;
  }
}
.login-item{
  position: relative;
}
.codeimg{
  width: 100%;
  height: 38px;
  position: absolute;
  top: 1px;
  right: 1px;
  width: 150px;
}
</style>